import {
  ON_FETCH_REPO,
  ON_FETCH_REPO_FAILURE,
  ON_FETCH_REPO_SUCCESS,
} from '../actions/Repo';

export interface IState {
  repoDetails: any;
  loading: boolean;
}

/** Reducer */
export default function repoReducer(state: IState, action: any) {
  switch (action.type) {
    case ON_FETCH_REPO:
      return {
        ...state,
        loading: true,
      };
    case ON_FETCH_REPO_SUCCESS:
      return {
        ...state,
        repoDetails: action.repoDetails,
        loading: false,
      };
    case ON_FETCH_REPO_FAILURE:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
